// extracted by mini-css-extract-plugin
export default {"articleSection":"Article_articleSection__Q2HWT","title":"Article_title__yhxLm"};